import { useMemo } from 'react';
import { HomeVehicleMosaic } from './HomeVehicleMosaic';

interface HomeNewArrivalsProps {
  vehicles: any[];
  store: any;
}

export function HomeNewArrivals({ vehicles, store }: HomeNewArrivalsProps) {
  const pool = useMemo(() => {
    const sorted = [...vehicles].sort((a, b) => {
      const aFeat = a.changed?.featured ? 1 : 0;
      const bFeat = b.changed?.featured ? 1 : 0;
      if (bFeat !== aFeat) return bFeat - aFeat;
      const aDate = a.changeDate || a.registrationDate || '';
      const bDate = b.changeDate || b.registrationDate || '';
      return String(bDate).localeCompare(String(aDate));
    });
    return sorted.slice(0, 20);
  }, [vehicles]);

  return (
    <HomeVehicleMosaic
      id="ofertas"
      title={store?.featuredTitle || 'Novidades no estoque'}
      lead="Acompanhe os novos carros disponíveis na loja, totalmente revisados e com garantia!"
      vehicles={pool}
      viewAllHref="/estoque"
      viewAllLabel="Ver estoque completo"
    />
  );
}
